import {
    Avatar,
    Box,
    Button,
    Container,
    Grid,
    InputAdornment,
    TextField,
    Typography,
    useTheme,
} from "@material-ui/core";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import { Search } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toastr from "toastr";
import _ from "underscore";
import updateImage from "../../assets/images/Exclude.png";
import pic2 from "../../assets/images/setUpMeetingDesc.png";
import pic4 from "../../assets/images/setUpMeetingInvite.png";
import pic3 from "../../assets/images/setUpMeetingSub.png";
import pic1 from "../../assets/images/setUpMeetingTitle.png";
import pic5 from "../../assets/images/setUpMeetingVIPCreated.png";
import { useStyles } from "../../components/common/MainStyles.jsx";
import { IsNullOrEmpty } from "../../helpers/utility";
import { uploadLivesRequest } from "../../store/file/file.actions";
import { getUploadedLiveImage } from "../../store/file/file.selector";
import { getCategoryRequest } from "../../store/shopping/shopping.actions";
import {
    getCartProductList,
    getCategoryList,
} from "../../store/shopping/shopping.selector";
import { createLiveStreamRequest } from "../../store/social/social.actions";
import { getLiveStream } from "../../store/social/social.selector";
import { searchUserRequest } from "../../store/user/user.actions";
import {
    getFollowingUsers,
    getImage,
    getSearchedUsers,
    getUserProfile,
} from "../../store/user/user.selector";
import {
    createVIPCircleRequest,
    getVIPCircleRequest,
} from "../../store/user/vipcircle/vipcircle.actions";
import { getSelectedVIPCircle } from "../../store/user/vipcircle/vipcircle.selector";

export default function CreateVipCircle(props) {
    const dispatch = useDispatch();
    const history = useNavigate();
    const [bannerImageSrc, setBannerImageSrc] = useState("");
    const [searchText, setSearchText] = useState("");
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [guests, setGuests] = useState([]);
    const [selectedMenu, setSelectedMenu] = useState("title");
    const [created, setCreated] = useState(false);
    const classes = useStyles();
    const theme = useTheme();

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [monthlySubscription, setMonthlySubscription] = useState("");
    const [annuallySubscription, setAnnuallySubscription] = useState("");
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();

    const { user, users, userProfile, thumbnail, vipCircle, categories } =
        useSelector((state) => {
            return {
                followingUsers: getFollowingUsers(state),
                user: getUserProfile(state),
                livestream: getLiveStream(state),
                products: getCartProductList(state),
                users: getSearchedUsers(state),
                thumbnail: getUploadedLiveImage(state),
                vipCircle: getSelectedVIPCircle(state),
                categories: getCategoryList(state),
                userProfile: getUserProfile(state),
            };
        });

    function getSteps() {
        return ["Title", "Description", "Subscription fee", "Invite"];
    }

    function getStepContent(stepIndex) {
        switch (stepIndex) {
            case 0:
                return (
                    <Container maxWidth="xl" className="my-4">
                        <Box className="mb-4">
                            <Typography
                                variant="h5"
                                component="p"
                                className={classes.title}
                            >
                                Give a name to your Circle
                            </Typography>
                            <Typography
                                variant="p"
                                component="p"
                                className={classes.subTitle}
                            >
                                Make it easier for people to find
                            </Typography>
                        </Box>
                        <Box
                            height="100%"
                            minHeight={"49.5vh"}
                            display={"flex"}
                            justifyContent="space-between"
                            flexDirection={"column"}
                        >
                            <div>
                                <div className="upload-btn-img my-4">
                                    <Avatar
                                        style={{ width: 150, height: 150 }}
                                        src={
                                            bannerImageSrc
                                                ? bannerImageSrc
                                                : updateImage
                                        }
                                    />
                                    <input
                                        type="file"
                                        name="banner_image"
                                        onChange={changeBanner}
                                    />
                                </div>

                                <TextField
                                    label="Title"
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Title"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    className="my-2 bg-white"
                                />
                            </div>
                            <div className="my-4">
                                <Button
                                    variant="contained"
                                    className={classes.bgwhite}
                                    onClick={() => CloseMe()}
                                >
                                    Previous
                                </Button>
                                <Button
                                    variant="contained"
                                    className="ml-2"
                                    color={
                                        !IsNullOrEmpty(title) ||
                                        IsNullOrEmpty(bannerImageSrc)
                                            ? "secondary"
                                            : "default"
                                    }
                                    disabled={
                                        IsNullOrEmpty(title) ||
                                        IsNullOrEmpty(bannerImageSrc)
                                    }
                                    onClick={() => handleNext()}
                                >
                                    Next
                                </Button>
                            </div>
                        </Box>
                    </Container>
                );
            case 1:
                return (
                    <Container maxWidth="xl" className="my-4">
                        <Box className="mb-4">
                            <Typography
                                variant="h5"
                                component="p"
                                className={classes.title}
                            >
                                Describe your live
                            </Typography>
                            <Typography
                                variant="p"
                                component="p"
                                className={classes.subTitle}
                            >
                                Tell the audience more about your live
                            </Typography>
                        </Box>
                        <Box
                            height="100%"
                            minHeight={"49.5vh"}
                            display={"flex"}
                            justifyContent="space-between"
                            flexDirection={"column"}
                        >
                            <div>
                                <TextField
                                    label="Your description"
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Your description"
                                    minRows={4}
                                    multiline
                                    value={description}
                                    onChange={(e) =>
                                        setDescription(e.target.value)
                                    }
                                    className="my-2 bg-white"
                                />
                                <p className="text-disabled text-small text-grey">
                                    Max 80 characters
                                </p>
                                {IsNullOrEmpty(description) ? (
                                    <p className="text-danger mb-2 text-small">
                                        *This fill is required
                                    </p>
                                ) : (
                                    <span />
                                )}
                            </div>
                            <Box>
                                <div className="my-4">
                                    <Button
                                        variant="contained"
                                        onClick={() => handleBack()}
                                        className={classes.bgwhite}
                                    >
                                        Previous
                                    </Button>
                                    <Button
                                        variant="contained"
                                        className="ml-2"
                                        color={
                                            !IsNullOrEmpty(description)
                                                ? "secondary"
                                                : "default"
                                        }
                                        disabled={IsNullOrEmpty(description)}
                                        onClick={() => handleNext()}
                                    >
                                        Next
                                    </Button>
                                </div>
                            </Box>
                        </Box>
                    </Container>
                );
            case 2:
                return (
                    <Container maxWidth="xl" className="my-2">
                        <Box className="my-2">
                            <Typography
                                variant="h5"
                                component="p"
                                className={classes.title}
                            >
                                Set subscription fee
                            </Typography>
                            <Typography
                                variant="p"
                                component="p"
                                className={classes.subTitle}
                            >
                                Only those who have an invitation link may
                                subscribe.
                            </Typography>
                        </Box>
                        <Box
                            height="100%"
                            minHeight={"49.5vh"}
                            display={"flex"}
                            justifyContent="space-between"
                            flexDirection={"column"}
                        >
                            <div>
                                <TextField
                                    label="Monthly Subscription"
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Monthly Fee 0.00"
                                    value={monthlySubscription}
                                    onChange={(e) => {
                                        setMonthlySubscription(e.target.value);
                                        setAnnuallySubscription(
                                            12 * e.target.value
                                        );
                                    }}
                                    className="my-2 bg-white"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                {user.country.currency}
                                            </InputAdornment>
                                        ),
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                / month
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <TextField
                                    label="Yearly Subscription"
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Yearly Fee 0.00"
                                    value={annuallySubscription}
                                    onChange={(e) =>
                                        setAnnuallySubscription(e.target.value)
                                    }
                                    className="my-2 bg-white"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                {user.country.currency}
                                            </InputAdornment>
                                        ),
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                / year
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </div>
                            <div className="my-4">
                                <Button
                                    variant="contained"
                                    onClick={() => handleBack()}
                                    className={classes.bgwhite}
                                >
                                    Previous
                                </Button>
                                <Button
                                    variant="contained"
                                    className="ml-2"
                                    color={
                                        !IsNullOrEmpty(title) &&
                                        !IsNullOrEmpty(description) &&
                                        !IsNullOrEmpty(monthlySubscription) &&
                                        !IsNullOrEmpty(annuallySubscription)
                                            ? "secondary"
                                            : "default"
                                    }
                                    disabled={
                                        !(
                                            !IsNullOrEmpty(title) &&
                                            !IsNullOrEmpty(description) &&
                                            !IsNullOrEmpty(
                                                monthlySubscription
                                            ) &&
                                            !IsNullOrEmpty(annuallySubscription)
                                        )
                                    }
                                    onClick={() => handleNext()}
                                >
                                    Next
                                </Button>
                            </div>
                        </Box>
                    </Container>
                );
            case 3:
                return created ? (
                    <Container maxWidth="xl" className="my-2">
                        <Box className="my-2">
                            <Typography
                                variant="h5"
                                component="p"
                                className={classes.title}
                            >
                                You have created a new circle
                            </Typography>
                            <Typography
                                variant="p"
                                component="p"
                                className={classes.subTitle}
                            >
                                Select the circle and go live
                            </Typography>
                        </Box>
                        <Box
                            textAlign="center"
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                            className="my-4"
                        >
                            <Avatar
                                className="mt-4"
                                style={{ width: 200, height: 200 }}
                                src={getImage(vipCircle.avatar)}
                            />
                            <p className={classes.gettingLabel}>
                                {vipCircle.title}
                            </p>
                            <p className={classes.gettingdesc}>
                                {vipCircle.description}
                            </p>
                        </Box>
                        <Button
                            variant="outlined"
                            color="default"
                            onClick={() => history("/page/select-vip-circle")}
                        >
                            Go to VIP list
                        </Button>
                        <Button
                            variant="contained"
                            className="ml-2"
                            color="secondary"
                            onClick={() => handleLive()}
                        >
                            Live now
                        </Button>
                    </Container>
                ) : (
                    <Container maxWidth="xl" className="my-2">
                        <Box className="my-2">
                            <Typography
                                variant="h5"
                                component="p"
                                className={classes.title}
                            >
                                Invite friends into your exclusive circle
                            </Typography>
                            <Typography
                                variant="p"
                                component="p"
                                className={classes.subTitle}
                            >
                                The selected person will receive a notification
                                and an invitation link to subscribe by email
                            </Typography>
                        </Box>
                        <Box
                            height="100%"
                            minHeight={"49.5vh"}
                            display={"flex"}
                            justifyContent="space-between"
                            flexDirection={"column"}
                        >
                            <div className="relative mb-3.5">
                                <input
                                    value={searchText}
                                    onChange={(e) =>
                                        setSearchText(e.target.value)
                                    }
                                    type="search"
                                    className="py-2.5 pl-12 w-full text-black-color placeholder:text-black-60 border border-black-10 rounded-[40px] text-md sm:text-md outline-none"
                                    placeholder="Search"
                                />

                                <span className="text-xl absolute top-2/4 -translate-y-2/4 left-5 text-black-60">
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2ZM0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 7.29583 11.5892 8.49572 10.8907 9.47653L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L9.47653 10.8907C8.49572 11.5892 7.29583 12 6 12C2.68629 12 0 9.31371 0 6Z"
                                            fill="black"
                                            fillOpacity="0.5"
                                        />
                                    </svg>
                                </span>
                            </div>
                            <Grid
                                container
                                spacing={2}
                                className={classes.guestList}
                            >
                                {searchedUsers &&
                                    searchedUsers
                                        .filter(
                                            (y) => y._id !== userProfile._id
                                        )
                                        .map((item, pos) => {
                                            let isActive =
                                                guests.indexOf(item._id) > -1;
                                            return (
                                                <Grid
                                                    item
                                                    key={item._id}
                                                    sm={4}
                                                    xs={4}
                                                    md={2}
                                                    lg={2}
                                                >
                                                    <Box
                                                        textAlign="center"
                                                        display={"flex"}
                                                        justifyContent="center"
                                                        alignItems={"center"}
                                                        flexDirection={"column"}
                                                    >
                                                        <Avatar
                                                            style={{
                                                                height: 64,
                                                                width: 64,
                                                                border: isActive
                                                                    ? "1px solid #0038FF"
                                                                    : "1px solid #CECECE",
                                                            }}
                                                            src={getImage(
                                                                item.attachments
                                                            )}
                                                            title={
                                                                item.fullName
                                                            }
                                                            alt={item.fullName}
                                                            onClick={() => {
                                                                let index =
                                                                    guests.findIndex(
                                                                        (x) =>
                                                                            x ===
                                                                            item._id
                                                                    );
                                                                if (
                                                                    index > -1
                                                                ) {
                                                                    let newGuests =
                                                                        guests.filter(
                                                                            (
                                                                                y
                                                                            ) =>
                                                                                y !==
                                                                                item._id
                                                                        );
                                                                    setGuests(
                                                                        newGuests
                                                                    );
                                                                } else {
                                                                    setGuests([
                                                                        ...guests,
                                                                        item._id,
                                                                    ]);
                                                                }
                                                            }}
                                                        />
                                                        <span
                                                            className="overflow-text text-small"
                                                            style={{
                                                                fontWeight:
                                                                    isActive
                                                                        ? 700
                                                                        : 400,
                                                            }}
                                                        >
                                                            {item.fullName}
                                                        </span>
                                                    </Box>
                                                </Grid>
                                            );
                                        })}
                            </Grid>
                            <div className="my-4">
                                <Button
                                    variant="contained"
                                    onClick={() => handleBack()}
                                    className={classes.bgwhite}
                                >
                                    Previous
                                </Button>
                                <Button
                                    className="ml-2"
                                    variant="contained"
                                    color={"secondary"}
                                    onClick={() => {
                                        handleSave();
                                    }}
                                >
                                    Next
                                </Button>
                            </div>
                        </Box>
                    </Container>
                );
            default:
                return "Unknown stepIndex";
        }
    }

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleClose = () => {
        if (selectedMenu === "title") {
            if (props.onClose) {
                props.onClose();
            } else {
                let vipCat = _.find(categories, (x) => x.name === "VIP Circle");
                history("/page/start-new-video", {
                    category: vipCat._id,
                });
            }
        }
        if (selectedMenu === "invite") {
            setSelectedMenu("subscription");
        }
        if (selectedMenu === "subscription") {
            setSelectedMenu("description");
        } else if (selectedMenu === "description") {
            setSelectedMenu("title");
        }
    };

    useEffect(() => {
        if (
            (vipCircle.title === title) &
            (vipCircle.description === description)
        ) {
            setCreated(true);
        }
    }, [vipCircle]);

    const handleSave = () => {
        dispatch(
            createVIPCircleRequest({
                title: title,
                description: description,
                thumbnail: thumbnail,
                monthlySubscription: monthlySubscription,
                annuallySubscription: annuallySubscription,
                guests: users
                    .filter((x) => guests.indexOf(x._id) > -1)
                    .map((x) => {
                        return {
                            userId: x._id,
                            name: x.fullName,
                            thumbnail: getImage(x.attachments),
                            status: "Invited",
                        };
                    }),
            })
        );
    };

    useEffect(() => {
        dispatch(searchUserRequest());
        dispatch(getVIPCircleRequest());
        if (categories.length === 0) {
            dispatch(getCategoryRequest());
        }
    }, []);

    useEffect(() => {
        if (vipCircle._id) {
            setTitle(vipCircle.title);
            setDescription(vipCircle.description);
            setMonthlySubscription(vipCircle.monthlySubscription);
            setAnnuallySubscription(vipCircle.annuallySubscription);
            setBannerImageSrc(getImage(vipCircle.avatar));
            let selectedGuests = vipCircle.guests.map((x) => x.userId);
            let guests = users.filter((x) => {
                return selectedGuests.indexOf(x._id) > -1;
            });
            setSelectedUsers(guests);
        }
    }, [vipCircle]);

    function copyToClipboard(str) {
        /* Get the text field */
        var copyText = document.getElementById(str);

        /* Select the text field */
        copyText.select();
        copyText.setSelectionRange(0, 99999); /* For mobile devices */

        /* Copy the text inside the text field */
        navigator.clipboard.writeText(copyText.value);

        /* Alert the copied text */
        toastr.success("Copied the referral code", "Copied to Clipboard");
    }

    let searchedUsers = users;
    if (!IsNullOrEmpty(searchText)) {
        searchedUsers = searchedUsers.filter((x) => {
            return (
                x.fullName.toLowerCase().indexOf(searchText.toLowerCase()) > -1
            );
        });
    }

    const changeBanner = async (e) => {
        const files = e.target.files[0];

        dispatch(uploadLivesRequest(files));

        const reader = new FileReader();
        reader.addEventListener(
            "load",
            function () {
                setBannerImageSrc(reader.result);
            },
            false
        );

        if (files) {
            reader.readAsDataURL(files);
        } else {
            setBannerImageSrc("");
        }
    };

    const handleLive = () => {
        let selectedCircle = vipCircle;
        let selectedCategory = categories.filter(
            (x) => x.name === "VIP Circle"
        );
        if (selectedCategory.length > 0) {
            selectedCategory = selectedCategory[0];
        }

        let data = {
            type: "main",
            category: selectedCategory._id,
            title: selectedCircle.title,
            contents: selectedCircle.description,
            attachments: selectedCircle.thumbnail,
            parent: selectedCircle._id,
            products: [],
            guests: [],
        };

        dispatch(
            createLiveStreamRequest({
                data: data,
                history: history,
            })
        );
    };

    let selectedCategory = categories.filter((x) => x.name === "VIP Circle");
    if (selectedCategory.length > 0) {
        selectedCategory = selectedCategory[0];
    }

    const CloseMe = () => {
        if (props.onClose) {
            props.onClose();
        } else {
            history("/page/start-new-video");
        }
    };

    return (
        <main className={classes.main}>
            <Grid container className="h-[100%]">
                <Grid item xs={12} sm={12} lg={8} md={8}>
                    <Grid container className="pb-4">
                        <Grid item xs={12} sm={12} className="mb-2">
                            <Stepper
                                style={{ background: "transparent" }}
                                activeStep={activeStep}
                                alternativeLabel
                            >
                                {steps.map((label, index) => (
                                    <Step key={label}>
                                        <StepLabel
                                            color={
                                                index === activeStep
                                                    ? theme.palette.secondary
                                                          .main
                                                    : theme.palette.primary
                                                          .contrastText
                                            }
                                        >
                                            {label}
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </Grid>
                        <Grid item sm={12} xs={12} className={classes.endDiv}>
                            <Grid container alignItems="center">
                                <Grid item xs={12} sm={12}>
                                    {getStepContent(activeStep)}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12} lg={4} md={4}>
                    <Box className="side-image-box">
                        <img
                            src={
                                activeStep === 0
                                    ? pic1
                                    : activeStep === 1
                                    ? pic2
                                    : activeStep === 2
                                    ? pic3
                                    : activeStep === 3
                                    ? !created
                                        ? pic4
                                        : pic5
                                    : pic1
                            }
                            alt="pic"
                            className="img-responsive  rounded-xl"
                        />
                    </Box>
                </Grid>
            </Grid>
        </main>
    );
}
